import LandingPage from "../LandingPage.jsx";

export default function LandingEn() {
  return <LandingPage forcedLang="en" />;
}